import React from "react";
import { Modal } from "react-bootstrap";
import classes from "./modalSkeleton.module.css";
import { mergeClass } from "../../utils/helper";
import { crossIcon, JMLogo } from "@/constant/imagePath";
import LoaderOverlay from "../LoaderOverlay";

export default function ModalSkeleton({
  size = "lg",
  show,
  setShow,
  header,
  footer,
  children,
  modalClass,
  hideHeaderBorder,
  headerStyles,
  borderRadius,
  showCloseIcon,
  width,
  borderLine = true,
  headerClass,
  modalStyles,
  headerHeading,
  className = "",
  showLogo,
  iconDiv,
  onHide = null,
  loading = false,
}) {
  function handleClose() {
    setShow("");
  }
  if (loading) return <LoaderOverlay />
  return (
    <>
      <Modal
        size={size}
        show={show}
        onHide={onHide ?? handleClose}
        centered
        className={`${[classes.modal, modalStyles, className].join(" ")}`}
      >
        {header && (
          <Modal.Header
            closeButton
            className={`${[classes.header, headerClass && headerClass].join(
              " "
            )}`}
            style={{ ...headerStyles }}
          >
            <h2 className={mergeClass("h4", headerHeading)}>{header}</h2>
          </Modal.Header>
        )}
        <div className="absolute top-4 left-4">
          {showLogo && (
            <div>
              <img src={JMLogo} alt="JMLogo" />
            </div>
          )}
        </div>
        {showCloseIcon && (
          <div
            id="modalSkeletonCloseButton"
            className={mergeClass(iconDiv, classes.iconBox)}
            onClick={onHide ?? handleClose}
          >
            <img src={crossIcon} alt="closeIcon" className={classes.icon} />
          </div>
        )}
        <Modal.Body
          className={`${[classes.body, modalClass && modalClass].join(" ")}`}
        >
          {children}
        </Modal.Body>
      </Modal>
    </>
  );
}
